import { Button, Tooltip } from "antd";
import { ColumnProps } from "antd/lib/table";
import SimpleTable from "components/Forms/DataGrid/SimpleTable";
import ShowIfTrue from "components/Forms/ShowIfTrue";
import TrackedBolSupplementaryInfoForm from "components/TrackedBolManagement/TrackedBolSupplementaryInfoForm";
import { ITrackedBol, TrackedBol, TrackedBolServiceCategory, TrackedBolStatus } from "Core/Api/Kopp/Api";
import NotificationUtility from "Core/NotificationUtility";
import Utility from "Core/Utility";
import _ from "lodash";
import * as React from "react";
import { NavLink } from "react-router-dom";
import TrackedBolHandler from '../TrackedBolHandler';

export interface Props {
    children?: React.ReactNode
}

export interface State {
    trackedBol?: TrackedBol;
    showDrawer?: boolean;
}

export default class TrackedBolTable extends React.Component<Props, State>
{
    handler: TrackedBolHandler;
    tableRef = React.createRef<SimpleTable<any>>();

    columns: Array<ColumnProps<TrackedBol>> = [
        {
            title: 'Click N Collect #',
            key: 'cngReferenceNumber',
            dataIndex: 'cngReferenceNumber'
        },
        {
            title: 'BL #',
            dataIndex: 'bolNumber',
        },
        {
            title: 'Date Submitted',
            dataIndex: 'creationDate',
            render: (text: any) => (!text ? '' : Utility.ToDateTimeString(text))
        },
        {
            title: 'Status',
            dataIndex: 'currentStatusForCustomer',
        },
        {
            title: 'Last Updated Date',
            dataIndex: 'modificationDate',
            render: (text: any) => (!text ? '' : Utility.ToDateTimeString(text))
        },
        {
            title: 'Service Category',
            dataIndex: 'serviceCategory',
            render:(text:TrackedBolStatus,record:TrackedBol,index)=><>{_.startCase(TrackedBolServiceCategory[text])}</>
        },
        {
            title: 'Consignee Name',
            dataIndex: 'consigneeName',
        },
        {
            title: '',
            render: (text: any, record: TrackedBol, index: number) => {
                return (
                    <>
                        <ShowIfTrue condition={this.canEdit(record)}>
                            <Tooltip title="Edit">
                                <Button type="link" icon="edit" onClick={x => this.onShowEditDrawer(record)}></Button>
                            </Tooltip>
                        </ShowIfTrue>
                        <Tooltip title="View Details">
                            <NavLink to={{ pathname: '/click-n-go/detail', search: '?id=' + record.id }}> <Button type="link" icon="book"></Button></NavLink>
                        </Tooltip>
                    </>
                );
            }
        }

    ];

    canEdit = (record: TrackedBol) => {
        return record.currentStatus == TrackedBolStatus.Submitted || record.currentStatus == TrackedBolStatus.UserInterventionRequired;
    }

    onShowEditDrawer = (record: TrackedBol) => {
        // this is done because the editor is expecting the tariffcode id
        record["tariffCodeDescriptionIds"] = Object.keys(record.tariffCodeDescription ?? []);
        this.setState({ showDrawer: true, trackedBol: record })
    }

    constructor(props: Props) {
        super(props)

        this.state = {
        }

        this.handler = new TrackedBolHandler(props);
    }

    updateSuplimentaryForm = (trackedBol: ITrackedBol) => {
        this.handler.UpdateTrackedBol(trackedBol).then(x => {
            NotificationUtility.success(`Successfully Updated Click N Go BOL#${trackedBol.bolNumber}`, null, 20, true);
            this.setState({ showDrawer: false, trackedBol: undefined });
            this.tableRef.current?.refresh();
        })
    }

    render() {
        return (
            <>
                <SimpleTable
                    tableKey="trackedBolList"
                    columns={this.columns}
                    dataFetcher={this.handler}
                    ref={this.tableRef}
                />
                {this.state.showDrawer &&
                    <TrackedBolSupplementaryInfoForm
                        drawerVisible={this.state.showDrawer}
                        trackedBol={this.state.trackedBol}
                        onComplete={this.updateSuplimentaryForm}
                        onCancel={() => this.setState({ showDrawer: false })}
                    />}
            </>
        )
    }
}
